import { 
    ACTIONS_MUDAR_PERIODO, 
    ACTIONS_MUDAR_MEDICO, 
    ACTIONS_NOVA_MARCACAO, 
    ACTIONS_LOGIN,
    ACTIONS_TOKEN  
} from './actionTypes';

export const actionsMudarPeriodo = value => ({
    type: ACTIONS_MUDAR_PERIODO,
    periodo: value
});

export const actionsMudarMedico = value => ({
    type: ACTIONS_MUDAR_MEDICO,
    medico: value
});

export const actionsNovaMarcacao = value => ({
    type: ACTIONS_NOVA_MARCACAO,
    marcacao: value
});

export const actionsLogin = value => ({
    type: ACTIONS_LOGIN,
    login: value
});

export const actionsToken = value => ({
    type: ACTIONS_TOKEN,
    tokenPortal: value
});